import * as BABYLON from 'babylonjs'

export function cargarMaterial (nombre, archivo) {
  var material = new BABYLON.StandardMaterial(nombre, window.scene)
  material.emissiveTexture = new BABYLON.Texture(archivo, window.scene)
  return material
}

export function initGeneralMaterials () {
  var reflectionTexture = new BABYLON.MirrorTexture('mirror', 512, window.scene, true)
  reflectionTexture.mirrorPlane = new BABYLON.Plane(0, -1.0, 0, -10.0)
  reflectionTexture = new BABYLON.CubeTexture('static/textures/TropicalSunnyDay', window.scene)
  reflectionTexture.level = 0.75 // Select the level (0.0 > 1.0) of the reflection
  // reflectionTexture.renderList = [objx];

  var materialPlaza = cargarMaterial('materialPlaza', 'static/textures/TilesPlain0072_1_S.jpg')
  materialPlaza.emissiveTexture.uScale = 120.0
  materialPlaza.emissiveTexture.vScale = 120.0

  var materialTerreno = cargarMaterial('materialTerreno', 'static/textures/TexturesCom_Grass0126_1_seamless_S.jpg')
  materialTerreno.emissiveTexture.uScale = 2000.0
  materialTerreno.emissiveTexture.vScale = 2000.0

  var materialSenderos = cargarMaterial('materialSenderos', 'static/textures/TexturesCom_TilesPlain0156_1_seamless_S.jpg')
  materialSenderos.emissiveTexture.uScale = 100.0
  materialSenderos.emissiveTexture.vScale = 2.0

  var materialIntersecciones = cargarMaterial('materialIntersecciones', 'static/textures/TexturesCom_TilesPlain0156_1_seamless_S.jpg')
  materialIntersecciones.emissiveTexture.uScale = 20.0
  materialIntersecciones.emissiveTexture.vScale = 20.0

  var materialCercaNatural = cargarMaterial('materialCercaNatural', 'static/textures/TexturesCom_Hedges0064_S.jpg')
  materialCercaNatural.emissiveTexture.uScale = 30.0
  materialCercaNatural.emissiveTexture.vScale = 1.0
  materialCercaNatural.backFaceCulling = false

  var materialMuros = cargarMaterial('materialMuros', 'static/textures/TexturesCom_TilesPlain0203_1_S.jpg')
  materialMuros.emissiveTexture.uScale = 50.0
  materialMuros.emissiveTexture.vScale = 1.0

  cargarMaterial('materialPuerta', 'static/textures/TexturesCom_DoorsMetalDouble0234_S.jpg')

  var materialBanda = cargarMaterial('materialBanda', 'static/textures/inicio_banda.jpg')
  materialBanda.backFaceCulling = false
  materialBanda.emissiveTexture.uScale = 50.0
  materialBanda.emissiveTexture.vScale = 1.0
  materialBanda.emissiveTexture.uOffset = 0.5

  var materialEdificioX = cargarMaterial('materialEdificioX', 'static/textures/TexturesCom_TilesPlain0021_1_seamless_S.jpg')
  materialEdificioX.backFaceCulling = false
  materialEdificioX.emissiveTexture.uScale = 10.0
  materialEdificioX.emissiveTexture.vScale = 10.0

  var materialCristalesEdificio = cargarMaterial('materialCristalesEdificio', 'static/textures/ventanalesEdificio.png')
  materialCristalesEdificio.emissiveTexture.uScale = 2.0
  materialCristalesEdificio.emissiveTexture.vScale = 60.0
  materialCristalesEdificio.backFaceCulling = false
  materialCristalesEdificio.reflectionTexture = reflectionTexture

  var materialCristalesEdificio1 = cargarMaterial('materialCristalesEdificio1', 'static/textures/ventanalesEdificio1.png')
  materialCristalesEdificio1.emissiveTexture.uScale = 2.0
  materialCristalesEdificio1.emissiveTexture.vScale = 60.0
  materialCristalesEdificio1.backFaceCulling = false
  materialCristalesEdificio1.reflectionTexture = reflectionTexture

  var materialCristalesEdificio2 = cargarMaterial('materialCristalesEdificio2', 'static/textures/ventanalesEdificio2.png')
  materialCristalesEdificio2.emissiveTexture.uScale = 2.0
  materialCristalesEdificio2.emissiveTexture.vScale = 60.0
  materialCristalesEdificio2.backFaceCulling = false
  materialCristalesEdificio2.reflectionTexture = reflectionTexture
}



// WEBPACK FOOTER //
// ./src/core/materials.js